const MOBILE_RULES: [(path: string) => boolean, string][] = [
  [(path) => path === "/" || path.startsWith("/recommended"), "home-menu"],
  [(path) => path === "/articles" || path.startsWith("/authors"), "explore-menu"],
  [(path) => path.startsWith("/collections"), "collections-menu"],
  [(path) => path.startsWith("/profile"), "profile-menu"],
];

const DESKTOP_RULES: [(path: string) => boolean, string][] = [
  [(path) => path === "/", "feed-menu"],
  [(path) => path === "/recommended", "foryou-menu"],
  [(path) => path === "/articles", "articles-menu"],
  [(path) => path.startsWith("/authors"), "authors-menu"],
  [(path) => path === "/collections", "collections-view-menu"],
  [(path) => path === "/collections/manage", "collections-manage-menu"],
  [(path) => path === "/profile", "history-menu"],
  [(path) => path === "/profile/following", "following-menu"],
  [(path) => path === "/profile/settings", "settings-menu"],
];

const firstMatch = (rules: [(path: string) => boolean, string][], path: string): string[] => {
  const rule = rules.find(([matches]) => matches(path));
  return rule ? [rule[1]] : [];
};

/** The classes that mark the active mobile and desktop nav items for a pathname; the styles are in site.css. */
export const navClasses = (path: string): string => [...firstMatch(MOBILE_RULES, path), ...firstMatch(DESKTOP_RULES, path)].join(" ");

/** The pathname of a router url (`/articles?category=ai` is `/articles`), without a trailing slash. */
export const pathnameOf = (url: string): string => {
  const path = url.split(/[?#]/)[0] || "/";
  return path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
};
